import { supabase } from '../supabaseClient';

/* Accès aux données « boamp_notices ». Chaque fonction renvoie la requête Supabase telle quelle
   (à attendre par l'appelant) : aucune logique métier ici. */

export function markTenderUnderReview(n) {
  return supabase
    .from('boamp_notices')
    .update({ qualification_status: 'a_instruire' })
    .eq('idweb', n.idweb);
}

export function fetchTenders() {
  return (
    supabase
      .from('boamp_notices')
      .select('*, boamp_document_analysis(*), boamp_documents(*)')
      .neq('rule_status', 'exclu_regle') // seuls les avis réellement candidats, pas le bruit exclu par les règles
      // idem pour les avis écartés par le LLM (bug corrigé le 2026-09-03) — en SQL NULL != 'x' ne
      // vaut jamais vrai, donc un .neq() seul masquerait aussi tout score_niveau NULL par erreur
      // (vécu le 2026-09-04 : un avis corrigé à la main via `set score_niveau=null` a disparu).
      .or('score_niveau.is.null,score_niveau.neq.non_pertinent')
      // "à instruire"/"écarté" restent chargés (nécessaire pour la relecture des motifs d'écartement)
      // — c'est le filtre par défaut côté écran (aoFilter.statut) qui les masque, pas la requête.
      .order('score_total', { ascending: false, nullsFirst: false })
  );
}

export function setTenderQualification(idweb, qualification_status) {
  return supabase.from('boamp_notices').update({ qualification_status }).eq('idweb', idweb);
}

export function dismissTender(f, motif, n) {
  return supabase
    .from('boamp_notices')
    .update({
      qualification_status: 'ecarte',
      ecarte_motif_categorie: f.categorie,
      ecarte_motif: motif,
    })
    .eq('idweb', n.idweb);
}
